/**
 * Retrieves the operating system (OS) and its version based on the user's browser User-Agent string.
 *
 * @returns {Object} An object containing:
 *   - `os` (string): The name of the detected operating system (e.g., 'Windows', 'macOS', 'Android', 'iOS', 'Linux', or 'Unknown OS').
 *   - `osVersion` (string): The version of the detected operating system (e.g., '10', '8.1', '14.5', or 'Unknown Version').
 *   - `userAgent` (string): The user agent string of the browser
 *
 * The function uses regular expressions to parse the User-Agent string for known OS patterns.
 * It covers major desktop and mobile operating systems, including specific Windows versions.
 *
 */
export const getDeviceDetails = () => {
  const userAgent = navigator.userAgent;
  let os = "Unknown OS";
  let osVersion = "Unknown Version";

  // Detect OS and version
  if (/Windows NT 10.0/i.test(userAgent)) {
    os = "Windows";
    osVersion = "10";
  } else if (/Windows NT 6.3/i.test(userAgent)) {
    os = "Windows";
    osVersion = "8.1";
  } else if (/Windows NT 6.2/i.test(userAgent)) {
    os = "Windows";
    osVersion = "8";
  } else if (/Windows NT 6.1/i.test(userAgent)) {
    os = "Windows";
    osVersion = "7";
  } else if (/Windows NT 6.0/i.test(userAgent)) {
    os = "Windows";
    osVersion = "Vista";
  } else if (/Windows NT 5.1/i.test(userAgent)) {
    os = "Windows";
    osVersion = "XP";
  } else if (/Mac OS X (\d+[_\.]\d+)/i.test(userAgent)) {
    os = "macOS";
    osVersion = userAgent.match(/Mac OS X (\d+[_\.]\d+)/i)[1].replace("_", ".");
  } else if (/Android (\d+[\.\d]+)/i.test(userAgent)) {
    os = "Android";
    osVersion = userAgent.match(/Android (\d+[\.\d]+)/i)[1];
  } else if (/iPhone OS (\d+[_\.]\d+)/i.test(userAgent)) {
    os = "iOS";
    osVersion = userAgent
      .match(/iPhone OS (\d+[_\.]\d+)/i)[1]
      .replace("_", ".");
  } else if (/iPad OS (\d+[_\.]\d+)/i.test(userAgent)) {
    os = "iOS";
    osVersion = userAgent.match(/iPad OS (\d+[_\.]\d+)/i)[1].replace("_", ".");
  } else if (/Linux/i.test(userAgent)) {
    os = "Linux";
    osVersion = "Unknown";
  }

  return { os, osVersion, userAgent };
};
